import React from "react";

import { HealthSummary } from "../Shared";

interface HeartRateData {
  date: string;
  low: number;
  high: number;
  avg: number;
}

interface HourlyHeartRateData {
  datetime: string;
  hour: number;
  low: number;
  high: number;
  avg: number;
}

interface HeartRateSummaryProps {
  filteredData: (HeartRateData | HourlyHeartRateData)[];
  metadata: {
    average: number;
    min: number;
    max: number;
  } | null;
  handlePrevious: () => void;
  handleNext: () => void;
  onDateSelect: (date: Date) => void;
  selectedDate: Date;
  selectedRange: string;
}

export const HeartRateSummary: React.FC<HeartRateSummaryProps> = ({
  filteredData,
  metadata,
  handlePrevious,
  handleNext,
  onDateSelect,
  selectedDate,
  selectedRange,
}) => {
  const getSummaryValues = (metadata: { average: number; min: number; max: number } | null, _filteredData: (HeartRateData | HourlyHeartRateData)[]) => [
    {
      label: "Low",
      value: metadata?.min ?? 0,
      color: "#3b82f6", // blue-500
      unit: "bpm",
    },
    {
      label: "Avg",
      value: metadata?.average ?? 0,
      color: "#22c55e", // green-500
      unit: "bpm",
    },
    {
      label: "High",
      value: metadata?.max ?? 0,
      color: "#ef4444", // red-500
      unit: "bpm",
    },
  ];

  return (
    <HealthSummary
      filteredData={filteredData}
      metadata={metadata}
      handlePrevious={handlePrevious}
      handleNext={handleNext}
      onDateSelect={onDateSelect}
      selectedDate={selectedDate}
      selectedRange={selectedRange}
      getSummaryValues={getSummaryValues}
    />
  );
};